import { Component } from '@angular/core';
import { AppSvgIconComponent } from '@vallift/ngl';
import type { DataLibraryListItemResponse } from '@core/api/workspace/models/dataLibraryListItemResponse';
import {
  dataLibraryTypeBadgeClass,
  dataLibraryTypeKey,
} from './data-library-type-styles';

const TYPE_ICONS: Record<string, string> = {
  text: 'assets/icons/text-string.svg',
  number: 'assets/icons/numeric.svg',
  date: 'assets/icons/calendar-blank-outline.svg',
  boolean: 'assets/icons/toggle-switch-outline.svg',
  enum: 'assets/icons/format-list-bulleted.svg',
  collection: 'assets/icons/view-sequential-outline.svg',
};

@Component({
  selector: 'app-data-library-type-cell',
  imports: [AppSvgIconComponent],
  template: `
    <div
      [class]="
        'inline-flex items-center gap-2 rounded-full px-2.5 py-1 ' + badgeClass
      ">
      @if (iconSrc) {
        <app-svg-icon class="shrink-0" [src]="iconSrc" [size]="18" />
      }
      <span class="text-body2 text-nowrap">{{ label }}</span>
    </div>
  `,
})
export class DataLibraryTypeCellComponent {
  /** Set by NGL DynamicRenderer. */
  rowData!: DataLibraryListItemResponse;

  get typeKey() {
    const item = this.rowData;
    if (!item) {
      return null;
    }
    return dataLibraryTypeKey(item.kind, item.valueType);
  }

  get badgeClass(): string {
    return dataLibraryTypeBadgeClass(this.typeKey);
  }

  get iconSrc(): string | null {
    const item = this.rowData;
    if (!item) {
      return null;
    }
    if (item.kind === 'collection') {
      return TYPE_ICONS['collection'];
    }
    if (item.valueType && TYPE_ICONS[item.valueType]) {
      return TYPE_ICONS[item.valueType];
    }
    return null;
  }

  get label(): string {
    const item = this.rowData;
    if (!item) {
      return '';
    }
    if (item.kind === 'collection') {
      return 'Collection';
    }
    if (!item.valueType) {
      return 'Variable';
    }
    return item.valueType.charAt(0).toUpperCase() + item.valueType.slice(1);
  }
}
